import React, { useEffect, useState} from "react";
import { useSelector, useDispatch } from 'react-redux';
import InfoTooltip from 'components/controls/InfoTooltip';
import { useTranslation } from 'react-i18next';
import ObsCov from 'components/controls/ObsCov';

export default function ObservationsMenu(props) {
  const { t } = useTranslation();
  const universe = useSelector((state) => state.universe);
  const zone = useSelector((state) => state.zone);
  const dispatch = useDispatch();

  useEffect(() => { 
    console.log('render ObservationsMenu')
  });

  function clickCharts(){
    dispatch({ type: 'SET_POPUP', payload: {
      title: "General Charts for "+universe+" Ocean at " + zone +" domain",
      content: "<div id='htmlCont' style='min-height: 380px; min-width:500px'><iframe style='border:none; width:100%; height:100%;' src='/charts/bichart.html?universe="+universe.toLowerCase()+"&area="+zone.toLowerCase()+"'></iframe></div>"
    }})
  }

  function enterCov(){
    document.querySelector('.covContainer').classList.add('cov'+universe)
    document.querySelector('.covContainer img').classList.add('cov'+universe)

  }

  function leaveCov(){
    document.querySelector('.covContainer').className = 'covContainer'
    document.querySelector('.covContainer img').className = 'covContainer'
  }

  return (
    <div className="menuContainer">
      <p className="menuTitle"><InfoTooltip title={t('menu.observations.info.title')} body={t('menu.observations.info.body')} /> {t('menu.observations.title')}</p>
      <ObsCov />
    </div>
  )
}


      //<div className="covContainer" onClick={() => clickCharts()} onMouseEnter={() => enterCov()} onMouseLeave={() => leaveCov()}>
        //<img src={imgCov}/>
        //<p>OBSERVATIONAL COVERAGE</p>
      //</div>